// package: eaconnect
// file: ea-hosting.proto

var ea_hosting_pb = require("./ea-hosting_pb");
var google_protobuf_empty_pb = require("google-protobuf/google/protobuf/empty_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var EAHostingService = (function () {
  function EAHostingService() {}
  EAHostingService.serviceName = "eaconnect.EAHostingService";
  return EAHostingService;
}());

EAHostingService.StreamLifecycleEvents = {
  methodName: "StreamLifecycleEvents",
  service: EAHostingService,
  requestStream: false,
  responseStream: true,
  requestType: ea_hosting_pb.StreamLifecycleEventsRequest,
  responseType: ea_hosting_pb.LifecycleUpdate
};

EAHostingService.StreamInstanceLogs = {
  methodName: "StreamInstanceLogs",
  service: EAHostingService,
  requestStream: false,
  responseStream: true,
  requestType: ea_hosting_pb.StreamInstanceLogsRequest,
  responseType: ea_hosting_pb.LogStreamFrame
};

EAHostingService.UploadEA = {
  methodName: "UploadEA",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.UploadEARequest,
  responseType: ea_hosting_pb.UploadEAResponse
};

EAHostingService.UploadEASource = {
  methodName: "UploadEASource",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.UploadEASourceRequest,
  responseType: ea_hosting_pb.CompileJob
};

EAHostingService.GetCompileJob = {
  methodName: "GetCompileJob",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.GetCompileJobRequest,
  responseType: ea_hosting_pb.CompileJob
};

EAHostingService.StartCompileJob = {
  methodName: "StartCompileJob",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.StartCompileJobRequest,
  responseType: ea_hosting_pb.CompileJob
};

EAHostingService.StartSetupJob = {
  methodName: "StartSetupJob",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.StartSetupJobRequest,
  responseType: ea_hosting_pb.StartSetupJobResponse
};

EAHostingService.GetSettingsSchema = {
  methodName: "GetSettingsSchema",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.GetSettingsSchemaRequest,
  responseType: ea_hosting_pb.GetSettingsSchemaResponse
};

EAHostingService.UploadSettingsSet = {
  methodName: "UploadSettingsSet",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.UploadSettingsSetRequest,
  responseType: ea_hosting_pb.SettingsSchemaResult
};

EAHostingService.GetSetupJob = {
  methodName: "GetSetupJob",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.GetSetupJobRequest,
  responseType: ea_hosting_pb.SetupJob
};

EAHostingService.CreateBrokerProfile = {
  methodName: "CreateBrokerProfile",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.CreateBrokerProfileRequest,
  responseType: ea_hosting_pb.BrokerProfile
};

EAHostingService.ListBrokerProfiles = {
  methodName: "ListBrokerProfiles",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.ListBrokerProfilesRequest,
  responseType: ea_hosting_pb.ListBrokerProfilesResponse
};

EAHostingService.CheckBrokerProfile = {
  methodName: "CheckBrokerProfile",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.CheckBrokerProfileRequest,
  responseType: ea_hosting_pb.CheckBrokerProfileResponse
};

EAHostingService.ValidateBrokerLogin = {
  methodName: "ValidateBrokerLogin",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.ValidateBrokerLoginRequest,
  responseType: ea_hosting_pb.ValidateBrokerLoginResponse
};

EAHostingService.GetBrokerProfileSymbols = {
  methodName: "GetBrokerProfileSymbols",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.GetBrokerProfileSymbolsRequest,
  responseType: ea_hosting_pb.GetBrokerProfileSymbolsResponse
};

EAHostingService.UpdateBrokerProfile = {
  methodName: "UpdateBrokerProfile",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.UpdateBrokerProfileRequest,
  responseType: ea_hosting_pb.BrokerProfile
};

EAHostingService.DeleteBrokerProfile = {
  methodName: "DeleteBrokerProfile",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.DeleteBrokerProfileRequest,
  responseType: google_protobuf_empty_pb.Empty
};

EAHostingService.CreateInstance = {
  methodName: "CreateInstance",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.CreateInstanceRequest,
  responseType: ea_hosting_pb.Instance
};

EAHostingService.GetInstance = {
  methodName: "GetInstance",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.GetInstanceRequest,
  responseType: ea_hosting_pb.Instance
};

EAHostingService.ListInstances = {
  methodName: "ListInstances",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.ListInstancesRequest,
  responseType: ea_hosting_pb.ListInstancesResponse
};

EAHostingService.DeleteInstance = {
  methodName: "DeleteInstance",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.DeleteInstanceRequest,
  responseType: google_protobuf_empty_pb.Empty
};

EAHostingService.StartInstance = {
  methodName: "StartInstance",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.StartInstanceRequest,
  responseType: ea_hosting_pb.Instance
};

EAHostingService.StopInstance = {
  methodName: "StopInstance",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.StopInstanceRequest,
  responseType: ea_hosting_pb.Instance
};

EAHostingService.RestartInstance = {
  methodName: "RestartInstance",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.RestartInstanceRequest,
  responseType: ea_hosting_pb.Instance
};

EAHostingService.UpdateInstanceRestartPolicy = {
  methodName: "UpdateInstanceRestartPolicy",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.UpdateInstanceRestartPolicyRequest,
  responseType: ea_hosting_pb.Instance
};

EAHostingService.UpdateSettings = {
  methodName: "UpdateSettings",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.UpdateSettingsRequest,
  responseType: ea_hosting_pb.SettingsVersion
};

EAHostingService.ListSettingsVersions = {
  methodName: "ListSettingsVersions",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.ListSettingsVersionsRequest,
  responseType: ea_hosting_pb.ListSettingsVersionsResponse
};

EAHostingService.RollbackSettings = {
  methodName: "RollbackSettings",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.RollbackSettingsRequest,
  responseType: ea_hosting_pb.SettingsVersion
};

EAHostingService.GetInstanceStatus = {
  methodName: "GetInstanceStatus",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.GetInstanceStatusRequest,
  responseType: ea_hosting_pb.InstanceStatus
};

EAHostingService.GetInstanceJournal = {
  methodName: "GetInstanceJournal",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.GetInstanceJournalRequest,
  responseType: ea_hosting_pb.GetInstanceJournalResponse
};

EAHostingService.GetInstanceMetrics = {
  methodName: "GetInstanceMetrics",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.GetInstanceMetricsRequest,
  responseType: ea_hosting_pb.InstanceMetrics
};

EAHostingService.ListEquityHistory = {
  methodName: "ListEquityHistory",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.ListEquityHistoryRequest,
  responseType: ea_hosting_pb.ListEquityHistoryResponse
};

EAHostingService.GetHostingOverview = {
  methodName: "GetHostingOverview",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.GetHostingOverviewRequest,
  responseType: ea_hosting_pb.HostingOverview
};

EAHostingService.ListUploads = {
  methodName: "ListUploads",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.ListUploadsRequest,
  responseType: ea_hosting_pb.ListUploadsResponse
};

EAHostingService.DismissUpload = {
  methodName: "DismissUpload",
  service: EAHostingService,
  requestStream: false,
  responseStream: false,
  requestType: ea_hosting_pb.DismissUploadRequest,
  responseType: ea_hosting_pb.DismissUploadResponse
};

exports.EAHostingService = EAHostingService;

function EAHostingServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

EAHostingServiceClient.prototype.streamLifecycleEvents = function streamLifecycleEvents(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(EAHostingService.StreamLifecycleEvents, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.streamInstanceLogs = function streamInstanceLogs(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(EAHostingService.StreamInstanceLogs, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.uploadEA = function uploadEA(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.UploadEA, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.uploadEASource = function uploadEASource(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.UploadEASource, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.getCompileJob = function getCompileJob(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.GetCompileJob, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.startCompileJob = function startCompileJob(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.StartCompileJob, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.startSetupJob = function startSetupJob(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.StartSetupJob, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.getSettingsSchema = function getSettingsSchema(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.GetSettingsSchema, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.uploadSettingsSet = function uploadSettingsSet(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.UploadSettingsSet, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.getSetupJob = function getSetupJob(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.GetSetupJob, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.createBrokerProfile = function createBrokerProfile(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.CreateBrokerProfile, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.listBrokerProfiles = function listBrokerProfiles(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.ListBrokerProfiles, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.checkBrokerProfile = function checkBrokerProfile(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.CheckBrokerProfile, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.validateBrokerLogin = function validateBrokerLogin(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.ValidateBrokerLogin, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.getBrokerProfileSymbols = function getBrokerProfileSymbols(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.GetBrokerProfileSymbols, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.updateBrokerProfile = function updateBrokerProfile(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.UpdateBrokerProfile, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.deleteBrokerProfile = function deleteBrokerProfile(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.DeleteBrokerProfile, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.createInstance = function createInstance(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.CreateInstance, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.getInstance = function getInstance(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.GetInstance, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.listInstances = function listInstances(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.ListInstances, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.deleteInstance = function deleteInstance(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.DeleteInstance, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.startInstance = function startInstance(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.StartInstance, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.stopInstance = function stopInstance(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.StopInstance, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.restartInstance = function restartInstance(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.RestartInstance, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.updateInstanceRestartPolicy = function updateInstanceRestartPolicy(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.UpdateInstanceRestartPolicy, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.updateSettings = function updateSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.UpdateSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.listSettingsVersions = function listSettingsVersions(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.ListSettingsVersions, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.rollbackSettings = function rollbackSettings(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.RollbackSettings, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.getInstanceStatus = function getInstanceStatus(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.GetInstanceStatus, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.getInstanceJournal = function getInstanceJournal(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.GetInstanceJournal, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.getInstanceMetrics = function getInstanceMetrics(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.GetInstanceMetrics, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.listEquityHistory = function listEquityHistory(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.ListEquityHistory, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.getHostingOverview = function getHostingOverview(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.GetHostingOverview, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.listUploads = function listUploads(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.ListUploads, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

EAHostingServiceClient.prototype.dismissUpload = function dismissUpload(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(EAHostingService.DismissUpload, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.EAHostingServiceClient = EAHostingServiceClient;

